import { apiClient, getAuthToken } from './client';

export type TagColor =
  | 'neutral'
  | 'green'
  | 'orange'
  | 'red'
  | 'blue'
  | 'purple'
  | 'teal'
  | 'brown';

export type TagOption = { value: string; label: string; color: TagColor };

export const queryTagOptions = async (
  input: { projectId?: string | null },
  token?: string,
  orgId?: string | null,
): Promise<TagOption[]> => {
  const params = new URLSearchParams();
  if (input.projectId) {
    params.set('projectId', input.projectId);
  }
  const query = params.toString();
  const path = query.length > 0 ? `/tags?${query}` : '/tags';
  return await apiClient.get<TagOption[]>(path, {
    token: token ?? getAuthToken(),
    orgId,
  });
};

export const updateTagColor = async (
  input: { name: string; color: TagColor },
  token?: string,
  orgId?: string | null,
): Promise<void> => {
  await apiClient.patch<{ status: 'updated' }>(
    '/tags/color',
    { name: input.name, color: input.color },
    {
      token: token ?? getAuthToken(),
      orgId,
      retries: 1,
    },
  );
};
